<form [formGroup]="form" class="row pane-container" (ngSubmit)="onSave()">
  <div class="col-12" [ngClass]="{ 'col-xl-7': !modalMode }">
    <app-digital-property-form-details
      #formDetailsComponent
      [workspaceId]="workspaceId"
      [tenantId]="tenantId"
      [formValidationRequest$]="formValidationRequest"
      [modalMode]="modalMode"
      (formChanged)="detailsChanged($event)"
    ></app-digital-property-form-details>

    @if (formDetailsComponent.isWebsite) {
      <div>
        <hr class="mb-4" aria-hidden="true" />
        <h2 class="margin-bottom-md">{{ 'label_monitoring' | translate }}</h2>

        <div class="margin-bottom d-flex flex-column">
          <div class="d-flex">
            <app-common-switch [name]="'dp-monitoring-switch'" [id]="'dp-monitoring-switch'" [(value)]="monitoringEnabled">
              <span class="switch-label visually-hidden">
                {{ 'monitoring_switch_label' | translate }}
              </span>
            </app-common-switch>
          </div>
        </div>

        @if (monitoringEnabled) {
          <app-monitoring-quick-setup
            #quickMonitoringSettings
            [url]="url"
            [formValidationRequest$]="formValidationRequest"
            [toolName]="toolName"
            [monitoring]="null"
          ></app-monitoring-quick-setup>
        }
      </div>
    }

    @if (isMobile) {
      <div>
        <div *appHasPermissions="addMobileAppsRequiredSecurity">
          <label class="label mb-1 text-nowrap">{{ 'upload_an_app' | translate }}</label>

          <ds-banner
            class="d-flex my-3"
            data-test-id="upload-app-info-banner"
            [state]="DsBannerState.info"
            [showTitle]="false"
            [showAction]="false"
            [showCloseButton]="true"
          >
            <div ds-banner-body>
              {{ 'upload_app_save_digital_asset_first' | translate }}
            </div>
          </ds-banner>

          <button type="button" ds-button disabled data-test-id="upload-app">
            <ds-icon [icon]="Icons.Plus" style="color: unset" class="me-1"></ds-icon>
            <span>{{ 'app' | translate }}</span>
          </button>
        </div>
      </div>
    }

    <div class="row margin-top-lg">
      @if (modalMode) {
        <div class="gap-2 d-flex">
          <button class="btn btn-primary" type="submit">
            {{ 'form_save' | translate }}
          </button>
          <button class="btn btn-outline-primary" type="reset" (click)="onCancel()">
            {{ 'form_cancel' | translate }}
          </button>
        </div>
      } @else {
        <div class="col d-flex">
          <button class="btn btn-outline-primary margin-right" type="reset" (click)="onCancel()">
            {{ 'form_cancel' | translate }}
          </button>
          <button class="btn btn-primary ms-auto" type="submit">
            {{ 'form_save' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</form>
